import moment from "moment";
import jwt_decode from "jwt-decode";

import { setIsModalLoading, setPopup, setRecaptcha } from "core/store/actionCreators";
import { phoneRegex } from "core/common/constants/regex";
import * as Constants from "core/common/constants/common";
import apiResponseStatus from "core/common/types/apiResponseStatus";
import { openPopup } from "components/Popup/Popup";
import aaSiteId from "core/common/types/aaSiteId";
import reviewsSiteId from "core/common/types/reviewsSiteId";
import {
    ACCESS_TOKEN_LOCAL_STORAGE_KEY, REFRESH_TOKEN_LOCAL_STORAGE_KEY
} from "core/common/constants/localstorage";
import { verticalsLogos, verticalsNewLogos } from "core/common/constants/common";
import { format } from "date-fns";

export const isValidPhoneNumber = (phoneNumber) =>
    phoneNumber && phoneRegex.test(phoneNumber);

export const loadingWrapper = async (dispatch, action) => {
    if (typeof action !== "function") return;

    try {
        dispatch(setIsModalLoading(true));
        const result = await action();
        return result;
    } catch (e) {
        if (e) {
            throw e;
        }
    } finally {
        dispatch(setIsModalLoading(false));
    }
};

export const renderFormikError = (fieldName, formik, errorClass) => {
    if (!fieldName) return null;
    const { touched, errors } = formik;

    if (touched[fieldName] && errors[fieldName]) {
        return <span className={errorClass}>{errors[fieldName]}</span>;
    }
    return null;
};

export const renderFormikArrayError = (fieldName, formik, index, errorClass) => {
    if (!fieldName) return null;
    const { touched, errors } = formik;

    if (touched[index] && errors[index]) {
        if (touched[index][fieldName] && errors[index][fieldName]) {
            return <span className={errorClass}>{errors[index][fieldName]}</span>;
        }
    }
    return null;
};

export const getFormikError = (fieldName, formik) => {
    if (!fieldName) return null;
    const { touched, errors } = formik;
    const error = touched[fieldName] && errors[fieldName];
    return error;
};

export const mobileMaxWidth = 1023;

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export const isMobile = () => window.matchMedia(`(max-width: ${mobileMaxWidth}px)`).matches;

export const isDesktop = () => !isMobile();

export const getHebrewMonthByDate = (date) => {
    let name = "";
    if (date) {
        date = date.split("/").length < 3 ? "00/" + date : date;
        const dateParts = date.split("/");
        name = `${Constants.hebrewMonths[parseInt(dateParts[1]) - 1]} ${dateParts[2]
            }`;
    }
    return name;
};

export const getMMYYbyDate = (date) => {
    let mmyy = "";
    if (date) {
        date = date.split("/").length < 3 ? "00/" + date : date;
        const dateParts = date.split("/");
        mmyy = `${dateParts[1]}${dateParts[2]}`;
    }
    return mmyy;
};

export const getLastXYears = (count) => {
    const currentYear = moment().year();
    const years = [];
    for (let i = 0; i < count; i++) {
        years.push(currentYear - i);
    }

    return years;
};

export const isDevEnvironment = document.location.hostname === "localhost";

export const recaptchaHelper = (dispatch, handleRecaptchaResponse, submitRef) => {
    dispatch(setRecaptcha({ handleRecaptchaResponse, submitRef }));

    return () => dispatch(setRecaptcha({ handleRecaptchaResponse: null, submitRef: null }));
};

export const recaptchaExecute = (recaptchaResponse, recaptchaRef) => {

    const shouldUseRecaptcha = true; //todo: fix it from Config

    if (shouldUseRecaptcha && recaptchaRef) {
        !recaptchaResponse && recaptchaRef.execute();

        if (!recaptchaResponse) return true;
    }
};

export const isSuccessfulRequest = (dispatch, response, shouldShowErrorPopup) => {

    const { result_status, message } = response || {};
    const isSuccessful = result_status === apiResponseStatus.SUCCESS;

    if (!isSuccessful && shouldShowErrorPopup) {
        openPopup(
            dispatch,
            "שגיאה",
            message || "שגיאה לא ידועה",
            "סגירה",
            () => dispatch(setPopup({ isOpen: false }))
        );
    }

    return isSuccessful;
};

export const isSuccessfulRequest2 = (response) => {

    const { result_status } = response || {};
    const isSuccessful = result_status === apiResponseStatus.SUCCESS;

    return isSuccessful;
};


export const groupBy = (xs, key, { takeFirstGroup = false } = {}) =>
    xs.reduce((rv, x) => {
        const props = key.split(".");

        let result = x;
        props.forEach(prop => { result = result[prop]; });
        if (takeFirstGroup && !rv[result]) {
            rv[result] = x;
        } else {
            (rv[result] = rv[result] || []).push(x);
        }

        return rv;
    }, {});

export const roundReviewScoreNearestHalf = (score) => {
    if (typeof score === "number" && score > 0) {
        return Math.round(score * 2) / 2;
    }

    return score;
};

export const aaSiteIdToReviewSiteId = {
    [aaSiteId.goldenPages]: reviewsSiteId.goldenPages,
    [aaSiteId.rest]: reviewsSiteId.rest,
    [aaSiteId.mishlohim]: reviewsSiteId.mishlohim,
    [aaSiteId.mithatnim]: reviewsSiteId.mithatnim,
    [aaSiteId.doctors]: reviewsSiteId.doctors
};


export const reviewSiteIdToAASiteId = {
    [reviewsSiteId.goldenPages]: aaSiteId.goldenPages,
    [reviewsSiteId.rest]: aaSiteId.rest,
    [reviewsSiteId.mishlohim]: aaSiteId.mishlohim,
    [reviewsSiteId.mithatnim]: aaSiteId.mithatnim,
    [reviewsSiteId.doctors]: aaSiteId.doctors,
    [reviewsSiteId.hoogel]: aaSiteId.hoogel,
};

export const colorPerVertical = {
    [reviewsSiteId.goldenPages]: "#ffd55e",
    [reviewsSiteId.rest]: "#ef4d38",
    [reviewsSiteId.mishlohim]: "#ef4d38",
    [reviewsSiteId.mithatnim]: "#fec7ca",
    [reviewsSiteId.doctors]: "#dd05c3",
    
};

export const calculatePercentage = (number, total) => {
    const percent = Math.ceil((number / total) * 100);
    return percent;
};

export const cacheObjectGet = (memorizeObj, baseKey, param, getValueFunc) => {
    if (param == null) return;

    const key = `${baseKey}_${param}`.replace(".", "_");

    if (memorizeObj[key]) {
        return memorizeObj[key];
    }

    const result = getValueFunc(param);
    memorizeObj = {
        ...memorizeObj,
        [key]: result
    };
    return result;
};

export const getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp(`[?&]${name.replace(/[\[\]]/g, "\\$&")}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const splitByNewLine = (text) => text?.split("\n");

export const convertDateURItoBlob = (dataURI) => {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], { type: mimeString });
    return blob;
};

export const IsAuthorized = () => {
    var result = false;

    const token = sessionStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
    if (token) {
        const jwt = jwt_decode(token);
        const now = Date.now();

        const expiredate = new Date(jwt.exp * 1000);
        const offsetMiliSecconds = 15000;

        result = (expiredate - offsetMiliSecconds) >= now;
    }

    return result;
};

export const HasAccessToken = () => {
    const token = sessionStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);

    return !!token;
};

export const HasRefreshToken = () => {
    const token = localStorage.getItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);

    return !!token;
};

export const JWT = () => {
    let jwt = null;

    const token = sessionStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);

    if (token) {
        jwt = jwt_decode(token);
    }

    return jwt;
};

export const getLogoBySiteId = (id) => {
    let logo = "";
    switch (id) {
        case aaSiteId.goldenPages:
            logo = verticalsLogos.d;
            break;
        case aaSiteId.rest:
            logo = verticalsLogos.rest;
            break;
        case aaSiteId.mishlohim:
            logo = verticalsLogos.rest;
            break;
        case aaSiteId.mithatnim:
            logo = verticalsLogos.Mitchatnim;
            break;
        case aaSiteId.doctors:
            logo = verticalsLogos.doctors;
            break;
        case aaSiteId.mishpati:
            logo = verticalsLogos.mishpati;
            break;
        default:
            break;
    }
    return logo;
};

export const getNewLogoBySiteId = (id) => {
    let logo = "";
    switch (id) {
        case aaSiteId.goldenPages:
            logo = verticalsNewLogos.d;
            break;
        case aaSiteId.rest:
            logo = verticalsNewLogos.rest;
            break;
        case aaSiteId.mishlohim:
            logo = verticalsNewLogos.rest;
            break;
        case aaSiteId.mithatnim:
            logo = verticalsNewLogos.Mitchatnim;
            break;
        case aaSiteId.doctors:
            logo = verticalsNewLogos.doctors;
            break;
        case aaSiteId.mishpati:
            logo = verticalsNewLogos.mishpati;
            break;
        default:
            break;
    }
    return logo;
};

// eslint-disable-next-line
Array.prototype.insert = function (item, before) {
    if (!item) return;

    if (before == null || before < 0 || before > this.length - 1) {
        this.push(item);
        return;
    }

    this.splice(before, 0, item);

    return this;
}

// eslint-disable-next-line
Array.prototype.distinct = function () {
    return Array.from(new Set(this));
}

export const numberWithCommas = (num) => {
    if (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return 0;
};

String.prototype.parseJsonDate = function () {
    let dateString = this.substr(6);
    return new Date(parseInt(dateString));
};

const lookupHours = [
    { start: "04:01", end: "12:00", text: "בוקר טוב!" },
    { start: "12:01", end: "16:00", text: "צהריים טובים!" },
    { start: "16:01", end: "18:00", text: "אחה”צ טובים!" },
    { start: "18:01", end: "21:00", text: "ערב טוב!" },
    { start: "21:01", end: "04:00", text: "לילה טוב!" },
]

export const getTime = () => {
    const fullHour = format(new Date(), "HH:mm")
    return lookupHours.find(i => fullHour >= i.start && fullHour <= i.end)?.text || lookupHours[lookupHours.length - 1].text
}

export const isIOS = () => {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}


export const equalsCheck = (a, b) => {
    if (!a || !b) return false
    return (JSON.stringify(a.sort()) === JSON.stringify(b.sort()));
}